import React, { useEffect, useState } from 'react';
import { UserFlowTypes } from '../../../userFlows';
import { ReservationTableColumns } from '../Reservations/reservationTableConfig';
import { Table } from '../../../../components/table/Table';
import { ACTION_BUTTON_LABEL } from '../Reservations/constants';
import { mobilescreensize } from '../../../../utilities/constants';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { accountSectionConfig } from '../../../userFlows/components/accountConfig';

interface IUnitType {
  [id: string]: string;
}

interface ICustomReservationData {
  unitTypeId: string;
  moveInDate: string;
  reservationDate: string;
  reservationCode: string;
  moveInButton: string;
}

const NoReservation = () => {
  return (
    <div className="noReservationWrapper">
      <FontAwesomeIcon
        iconClassName="FaInfoCircle"
        style={{
          fontSize: 24,
        }}
      />
      <div className="noReservation">{accountSectionConfig.noReservations}</div>
    </div>
  );
};

export const ReservationPage = ({
  reservationData,
  ledgerId,
  apiRes,
}: UserFlowTypes.TReservationPage) => {
  const [customReservationData, setCustomReservationData] = useState<
    ICustomReservationData[]
  >([]);
  const {
    data: {
      data: reservationList = [],
      relational_data: relationalData = {},
    } = {},
  } = reservationData || {};
  const formatterProps = { ledgerId, apiRes };
  const tableProps = {
    tableWidth:
      window.innerWidth <= mobilescreensize ? `calc(100vw - 48px)` : `auto`,
  };

  useEffect(() => {
    if (reservationList.length) {
      const mappedData = reservationList.map(
        (reservation: UserFlowTypes.TReservation) => {
          const unit_type_description = relationalData.unit_type.find(
            (type: IUnitType) => type.id === reservation.unit_type_id
          )?.value.description;
          const unit_label = relationalData.unit.find(
            (eachUnit: IUnitType) => eachUnit.id === reservation.unit_id
          )?.label;
          return {
            unitTypeId: reservation.unit_id
              ? `${unit_type_description} (${unit_label})`
              : unit_type_description,
            moveInDate: reservation.rental_info?.move_in_date,
            reservationDate: reservation.reservation_date,
            reservationCode: reservation.reservation_code,
            moveInButton: {
              label: ACTION_BUTTON_LABEL,
              unitTypeId: reservation.unit_type_id,
              reservationId: reservation.id,
            },
          };
        }
      );
      setCustomReservationData(mappedData);
    }
  }, [reservationData.data]);

  return (
    <div className="reservationTableContainer">
      {!!customReservationData.length ? (
        <Table
          columns={ReservationTableColumns}
          data={customReservationData}
          formatterProps={formatterProps}
          tableProps={tableProps}
        />
      ) : (
        <NoReservation />
      )}
    </div>
  );
};
